export default __webpack_public_path__ + "static/media/fiveG.99a32536.png";